// extracted by mini-css-extract-plugin
module.exports = {"pintxo-icon":"Icon_pintxo-icon__fqL0I"};